/**
 * Class ApexChartHelper.js
 *
 * @class ApexChartHelper
 * @date
 * @author
 * @copyright UniWeb bvba 2024
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/ApexChartHelper.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
import {ucfirst} from "../plugins/uniweb";

export default class ApexChartHelper {
  constructor(store, translationManager) {
    this._store = store
    this._trans = translationManager;
  }

  getMonthTranslations() {
    return {
      defaultLocale: this._store.state.currentLanguage,
      locales: [{
        name: this._store.state.currentLanguage,
        options: {
          months: [
            ucfirst(this._trans.t('date.MMMM-01')),
            ucfirst(this._trans.t('date.MMMM-02')),
            ucfirst(this._trans.t('date.MMMM-03')),
            ucfirst(this._trans.t('date.MMMM-04')),
            ucfirst(this._trans.t('date.MMMM-05')),
            ucfirst(this._trans.t('date.MMMM-06')),
            ucfirst(this._trans.t('date.MMMM-07')),
            ucfirst(this._trans.t('date.MMMM-08')),
            ucfirst(this._trans.t('date.MMMM-09')),
            ucfirst(this._trans.t('date.MMMM-10')),
            ucfirst(this._trans.t('date.MMMM-11')),
            ucfirst(this._trans.t('date.MMMM-12')),
          ],
        }
      }]
    }
  }
}